import React, { Component } from 'react';

export default class SelectList extends Component {
  constructor(props = { selectedId, list, onChoise, onReset, LayoutComponent }){
    super(props);
    this.state = {
      selectedId: this.props.selectedId,
      list: this.props.list || []
    }
  }
  componentDidMount(){
    let { selectedId } = this.state;
    if (selectedId) this.itemSelected(selectedId);
  }
  componentWillReceiveProps(nextProps){
    if (!nextProps.selectedId) this.resetList();
  }
  getItemById(id){
    return this.state.list.find(item => item.id === id)
  }
  activeItem(id){
    let listCopy = this.state.list.slice();
    for (let item of listCopy){
      if (item.id === id){
        item.active = !item.active;
      }
    }
    this.setState({ list: listCopy })
  }
  inactiveItems(){
    let listCopy = this.state.list.slice();
    for (let item of listCopy) {
      item.active = false;
    }
    this.setState({ list: listCopy });
  }
  itemSelected(itemId){
    this.inactiveItems();
    this.activeItem(itemId);
    this.props.onChoise(this.getItemById(itemId));
  }
  resetList(){
    this.inactiveItems();
    this.props.onReset();
  }
  render(){
    let { LayoutComponent } = this.props;
    let layoutProps = {
      list: this.state.list,
      onItemSelect: (itemId) => this.itemSelected(itemId),
      onResetList: () => this.resetList()
    }
    return (
      <LayoutComponent { ...layoutProps } />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SelectList/index.js